import { axiosLib } from '@/lib/axios';
import { showToast } from '@/services/toast-service';
import { getColocApiCallProperties } from '@/lib/coloc-api';

export const useDeleteDiscount = (contractId: number, refreshDiscounts: () => Promise<void>) => {
  const deleteDiscount = async (discountId: number) => {
    try {
      const response = await axiosLib.delete(
        `/admin/contracts/${contractId}/discounts/${discountId}`,
        {
          ...getColocApiCallProperties(),
        }
      );

      if (response.data && response.data.success) {
        await refreshDiscounts();
        showToast.success({ text: response.data.success_message || 'Discount deleted!' });
      } else {
        showToast.error({ text: response.data.error_message || 'Failed to delete discount.' });
      }
    } catch (error: any) {
      showToast.error({
        text: error.response?.data?.error_message || 'Failed to delete discount.',
      });
    }
  };

  return { deleteDiscount };
};
